var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("collapsible-card", {
    attrs: {
      "collapse-id": "starred-linked-app-card",
      "store-path": "starredLinkedApplication",
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("client-profile.pinnedApplication"))),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "linked-application-item",
              _vm._b(
                {
                  on: {
                    save: _vm.handleSave,
                    "copy-application": _vm.handleCopyApplication,
                  },
                },
                "linked-application-item",
                Object.assign({}, _vm.application, {
                  clientProfileId: _vm.clientProfileId,
                  allowDelete: false,
                }),
                false
              )
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }